import { render, staticRenderFns } from "./FcArticles.vue?vue&type=template&id=287d8d17&"
import script from "./FcArticles.vue?vue&type=script&lang=js&"
export * from "./FcArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports